import * as Immutable from 'immutable';
import * as ActionTypes from '../constants/ActionTypes';

const searchState = Immutable.fromJS({
  loading: false,
  currentSearchTerm: '',
  selectedMerchantId: null,
  showCreate: false
});

function setState(state, newState) {
  return state.merge(newState);
}

export function search(state = searchState, action) {
  switch(action.type) {
    case ActionTypes.SEARCHING:
      return setState(state, state.set('loading', action.payload));

    case ActionTypes.SET_SEARCH_ID:
      return setState(state, state.set('selectedMerchantId', action.payload));

    case ActionTypes.SET_SEARCH_TERM:
      return setState(state, state.set('currentSearchTerm', action.payload));

    case ActionTypes.SHOW_CREATE:
      return setState(state, state.set('showCreate', action.value))

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/search.js